module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(typeof _vm.builder !== 'undefined' && typeof _vm.builder.venue !== 'undefined' && _vm.builder.venue.id === 264) ? _c('link', {
    attrs: {
      "href": "assets/css/venue-264.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid title-bar"
  }, [_c('div', {
    staticClass: "vertical"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$root.hasOwnProperty('headers')) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    class: {
      'no-breadcrumbs': !_vm.$root.headers.hasOwnProperty('breadcrumbs') || (_vm.$root.headers.hasOwnProperty('breadcrumbs') && _vm.$root.headers.breadcrumbs.length === 0) && !_vm.venue
    }
  }, [(_vm.$root.headers.hasOwnProperty('navigate') && _vm.$root.headers.navigate != null && !_vm.$root.headers.navigate.back) ? _c('a', {
    staticClass: "fa fa-chevron-left breadcrumbs-icon",
    on: {
      "click": _vm.back
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.$root.headers.hasOwnProperty('breadcrumbs') && _vm.venue) ? _c('a', {
    staticClass: "breadcrumb-link",
    on: {
      "click": _vm.changeVenue
    }
  }, [_vm._v(_vm._s(_vm.venue.name + ' (' + _vm.venue.town + ') ' + (_vm.$root.headers.breadcrumbs.length > 0 ? ' / ' : ' ')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$root.headers.breadcrumbs), function(breadcrumb, key) {
    return (_vm.$root.headers.hasOwnProperty('breadcrumbs') && _vm.venue) ? _c('router-link', {
      key: key,
      staticClass: "breadcrumb-link",
      attrs: {
        "to": {
          name: breadcrumb.to.name,
          query: (Object.isEmpty(breadcrumb.to.query) || !breadcrumb.to.query ? {
            a: '1'
          } : Object.filter(breadcrumb.to.query, function(obj) {
            return obj == undefined || obj == null
          }))
        }
      },
      domProps: {
        "innerHTML": _vm._s(breadcrumb.title + (key == _vm.$root.headers.breadcrumbs.length - 1 ? ' ' : ' /&nbsp;'))
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), (_vm.$root.headers.hasOwnProperty('title')) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s((_vm.$root.headers.title ? _vm.$root.headers.title : (_vm.venue != null ? _vm.venue.name : '')))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "switch-package-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show_switch_option == 'weeks') ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(this.$root.locale.booking.packages.text_switch_to_full_weeks)
    },
    on: {
      "click": _vm.switcher
    }
  }) : (_vm.show_switch_option == 'days') ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(this.$root.locale.booking.packages.text_switch_to_individual_days)
    },
    on: {
      "click": _vm.switcher
    }
  }) : _vm._e()])], 1)]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2852bda5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 160
// module chunks = 0